

<template>
  <div>
    <div class="header p-4 d-flex justify-content-between">
      <h3 class="m-0 p-0">{{ title }}</h3>
      <div class="clickable" @click="$emit('close')">
        <iconClose class="icon icon-close"></iconClose>
      </div>
    </div>
    <div class="px-4 pb-4">
      <ul >
        <li v-for="term in content" :key="term">
          {{ term }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import iconClose from '@/assets/icons/close-dark.svg'

export default {
  name: 'CiCancellationTermsModal',

  components: {
    iconClose,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    content: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
